import { AutogenLayoutEquipmentMatchDetail } from "./autogen/AutogenLayoutEquipmentMatchDetail";

export class EquipmentMatchDetail extends AutogenLayoutEquipmentMatchDetail {
}
